<script>
import wrapManage from './wrapManage'
import WrapContent from './components/wrapContent'
import ToBind from './components/toBind'
import BtnList from './components/btnList'

wrapManage.WrapContent = WrapContent
wrapManage.ToBind = ToBind
wrapManage.BtnList = BtnList

export default wrapManage
</script>




